import type { ResourceStoreData } from '@atlassian/react-resource-router';
import { RESOURCE_TYPE_WORKSPACE_CONTEXT } from './constants.tsx';
import type {
	AdminSettingsResponse,
	AdminSettingsMap,
	BannerSettings,
	BannerSettingsResponse,
} from './types.tsx';

export function extractResourceStatePromise(resourceState: ResourceStoreData) {
	return resourceState?.[RESOURCE_TYPE_WORKSPACE_CONTEXT]?.state?.promise;
}

export const getAdminSettingsUrl = (workspaceId: string) =>
	`/gateway/api/jsm/assets/workspace/${workspaceId}/v1/admin/settings`;

export const getBannerSettingsUrl = (workspaceId: string) =>
	`/gateway/api/jsm/assets/workspace/${workspaceId}/v1/admin/banner-settings`;

export const transformAdminSettingsResponse = (
	response: AdminSettingsResponse,
): AdminSettingsMap => {
	return response.reduce((acc: AdminSettingsMap, setting) => {
		acc[setting.key] = setting;
		return acc;
	}, {});
};

export const transformBannerSettings = (
	bannerSettings: BannerSettingsResponse | BannerSettings,
) => {
	return {
		...bannerSettings,
		content:
			typeof bannerSettings.content === 'string'
				? JSON.parse(bannerSettings.content)
				: JSON.stringify(bannerSettings.content),
	};
};
